export default __webpack_public_path__ + "static/media/trending_buy.51007311.png";